module.exports = __webpack_public_path__ + "img/PR6430.e19003b1.png";